export default __webpack_public_path__ + "static/media/calendar_logo.af15e7c0.png";